import * as React from "react";
import UserProfile from "./UserProfile";

export const UserProfileControls = () => {
    return <UserProfile />;
};

export default UserProfileControls;
